import React from 'react';
import { Icon } from './Icon.js';
export const IconTreasureChestFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M5 6V7C5 7.55228 5.44772 8 6 8C6.55228 8 7 7.55228 7 7V6H12V8.25C12 9.76878 10.7688 11 9.25 11H2.75C1.23122 11 0 9.76878 0 8.25V6H5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9 1.0752C10.6323 1.40659 11.8792 2.79817 11.9912 4.5H9V1.0752Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M7.5 4.5H4.5V1H7.5V4.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3 4.5H0.00878906C0.120822 2.79817 1.36774 1.40659 3 1.0752V4.5Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconTreasureChestFill12.js.map